export const HIGH_SIMILARITY = 70
export const MEDIUM_SIMILARITY = 40
